import React, { useMemo } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import HomePage from "scenes/home";
import ImpressumPage from "scenes/impressum";
import DatenschutzPage from "scenes/datenschutz";

import LoginPage from "scenes/auth/LoginPage";
import RegisterPage from "scenes/auth/RegisterPage";
import ForgotPasswordPage from "scenes/auth/ForgotPasswordPage";
import ResetPasswordPage from "scenes/auth/ResetPasswordPage";
import VerifyEmailPage from "scenes/auth/VerifyEmailPage";

import BookingPage from "scenes/booking";
import BookingSuccessPage from "scenes/booking/SuccessPage";

import KontoPage from "scenes/konto";
import ReschedulePage from "scenes/konto/ReschedulePage";

import ScrollToTop from "utils/ScrollToTop";
import useAuthSync from "utils/useAuthSync";
import { themeSettings } from "./theme";

const RequireAuth = ({ children }) => {
  const token = useSelector((s) => s.token);
  if (!token) return <Navigate to="/einloggen" replace />;
  return children;
};

const AppShell = () => {
  useAuthSync();
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/datenschutz" element={<DatenschutzPage />} />

      <Route path="/einloggen" element={<LoginPage />} />
      <Route path="/registrieren" element={<RegisterPage />} />
      <Route path="/auth/verifizieren" element={<VerifyEmailPage />} />
      <Route path="/auth/passwort-vergessen" element={<ForgotPasswordPage />} />
      <Route path="/auth/passwort-zuruecksetzen" element={<ResetPasswordPage />} />

      <Route path="/buchen" element={<BookingPage />} />
      <Route path="/buchen/erfolg" element={<BookingSuccessPage />} />

      <Route path="/konto" element={<RequireAuth><KontoPage /></RequireAuth>} />
      <Route
        path="/konto/buchungen/:id/aendern"
        element={<RequireAuth><ReschedulePage /></RequireAuth>}
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  const theme = useMemo(() => createTheme(themeSettings("light")), []);
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ScrollToTop />
          <AppShell />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
